import { Typography, useTheme } from "@mui/material";

interface PropType {
  title: string;
  fontfamily?: string;
  size?: string;
  weight?: string;
  color?: string;
}
const Title = (props: PropType) => {
  const theme = useTheme();
  const {
    title,
    fontfamily = theme.font?.fontFamily.primary,
    size = theme.font?.fontSize.large,
    weight = theme.font?.fontWeight.thick,
    color = theme?.color?.primary,
  } = props;
  return (
    <Typography
      sx={{
        fontFamily: fontfamily,
        fontWeight: weight,
        fontSize: size,
        color: color,
      }}
    >
      {title}
    </Typography>
  );
};
export default Title;
